import React from 'react';
import { connect } from 'react-redux';
import SMStream from 'dash-front/components/sm/streams/SMStream2';
import eventify from 'Eventify';
import _ from 'lodash';
import { loadOdds } from 'dash-front/components/sm/pages/actions';
import { lifecycle } from 'recompose';

const oddsWidgets = (event, oddsProvider) => {
    const { eventId } = event;

    const props = { eventId, oddsProvider };

    return [
        {
            groupTitle: '3way odds',
            name: 'MatchOddsSMWidget',
            groupKey: `match-${eventId}`,
            props: {
                ...props,
                oddsType: 'match',
            },
        },
        {
            groupTitle: 'Next Goal',
            name: 'MatchOddsSMWidget',
            groupKey: `nextGoal-${eventId}`,
            props: {
                ...props,
                oddsType: 'nextGoal',
            },
        },
        {
            groupTitle: 'Both Team To Score',
            name: 'MatchOddsSMWidget',
            groupKey: `btts-${eventId}`,
            props: {
                ...props,
                oddsType: 'btts',
            },
        },
        ..._.range(6)
            .map(i => 'goals|' + (i + 0.5))
            .map(type => ({
                groupTitle: 'OverUnder',
                name: 'MatchOddsSMWidget',
                groupKey: `ou-${eventId}`,
                props: {
                    ...props,
                    oddsType: type,
                },
            })),
    ];
};

const oddsBoostersWidgets = (event, oddsProvider) => {
    const { eventId } = event;

    return [
        {
            groupTitle: 'Match Odds Booster V1',
            name: 'MatchOddsBoosterSMWidget',
            groupKey: `1way-${eventId}`,
            props: {
                eventId,
                oddsHomeNew: 'Y',
                oddsHomeOld: 'X',
                oddsDrawNew: 'Y',
                oddsDrawOld: 'X',
                oddsAwayNew: 'Y',
                oddsAwayOld: 'Y',
                layoutType: '3way_odds',
            },
            key: `match-${eventId}`,
        },
        {
            groupTitle: 'Match Odds Booster V2',
            groupKey: `3way_odds_no_old-${eventId}`,
            name: 'MatchOddsBoosterSMWidget',
            props: {
                eventId,
                oddsHomeNew: 'Y',
                oddsHomeOld: 'X',

                oddsAwayNew: 'Y',
                oddsAwayOld: 'Y',
                layoutType: '3way_odds_no_old',
            },
        },
        {
            groupTitle: '2 way odds booster',
            groupKey: `3way-${eventId}`,
            name: 'MatchOddsBoosterV2SMWidget',
            props: {
                eventId,
                oddsHomeNew: 'Y',
                oddsHomeOld: 'X',

                oddsAwayNew: 'Y',
                oddsAwayOld: 'Y',
                layoutType: '2way_odds',
                showMatchInfo: true,
            },
        },
    ];
};
const singleOddsBoostersWidgets = (event, oddsProvider) => {
    const { eventId } = event;
    return [
        {
            groupTitle: 'Single Outcome Booster',
            name: 'SingleOddBoosterMatchSMWidget',
            props: {
                eventId,
                oddsHomeNew: 'Y',
                oddsHomeOld: 'X',
                layoutType: 'textual_odds',
            },
            key: `ob-circle-odds-${eventId}`,
        },
        {
            groupTitle: 'Single Outcome Booster',
            groupKey: 'CircleOdds-2',
            name: 'SingleOddBoosterMatchSMWidget',
            props: {
                eventId,
                oddsHomeNew: 'Y',
                oddsHomeOld: 'X',
                layoutType: 'circle_odds',
            },
            key: `ob-circle-odds-${eventId}`,
        },
        {
            groupTitle: 'Single Outcome Booster V2',
            groupKey: 'SingleBoosterV2',
            name: 'SingleOddBoosterMatchV3',
            props: {
                eventId,
                oddsHomeNew: 'Y',
                oddsHomeOld: 'X',
            },
            key: `ob-single-booster-v2-${eventId}`,
        },
        {
            groupTitle: 'Single Outcome Booster V3',
            groupKey: 'SingleBoosterV3',
            name: 'SingleOddBoosterMatchV3SMWidget',
            props: {
                eventId,
                oddsHomeNew: 'Y',
                oddsHomeOld: 'X',
            },
            key: `ob-single-booster-v3-${eventId}`,
        },
    ];
};
const freeBetWidgets = (event, oddsProvider) => {
    const { eventId } = event;
    return [
        {
            groupTitle: 'FreeBet V1',
            groupKey: 'Freebet-1',
            name: 'FreeBetMatchSMWidget',
            props: {
                eventId,
                oddsHomeNew: 'X',
                oddsDrawNew: 'Y',
                oddsAwayNew: 'Z',
                showFullTeamName: true,
                layoutType: '3way_odds',
            },
            key: `ob-freebet-v1-${eventId}`,
        },
        {
            groupTitle: 'FreeBet V2',
            groupKey: 'Freebet-2',
            name: 'FreeBetMatchSMWidget',
            props: {
                eventId,
                layoutType: 'no_odds',
            },
            key: `ob-freebet-v2-${eventId}`,
        },
    ];
};

const OddsStreamEnhanced = connect(
    state => ({
        event: state.smBrowser.event,
        user: state.user,
        smWidgets:
            state.smBrowser.eventsOdds && state.smBrowser.eventsOdds.length > 0
                ? oddsWidgets(state.smBrowser.event, _.get(state, `user.props.oddsProvider`))
                : [],
    }),
    dispatch => ({
        dispatch,
        loadOdds,
    }),
)(
    lifecycle({
        componentDidMount() {
            const { loadOdds, dispatch, user, event } = this.props;
            dispatch(loadOdds(event.eventId, user.props.oddsProvider));
        },
    })(SMStream),
);

class EventSMB extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount = () => {};

    state = {};

    renderOddsStream = () => {
        const {
            user,
            params: { eventId },
            event,
        } = this.props;
        const oddsProvider = user.props.oddsProvider;

        if (!oddsProvider)
            return (
                <div>
                    <h1>Odds provider is not defined for</h1>
                </div>
            );

        return <OddsStreamEnhanced title="Odds" />;
    };

    render() {
        let {
            user,
            params: { eventId },
            event,
        } = this.props;

        const oddsProvider = user.props.oddsProvider;

        event = eventify(event);

        return (
            <div>
                <div>event page</div>
                {this.renderOddsStream()}
                <SMStream smWidgets={oddsBoostersWidgets(event)} title="3way odds booster" />
                <SMStream smWidgets={singleOddsBoostersWidgets(event)} title="Single odds booster" />
                <SMStream smWidgets={freeBetWidgets(event)} title="FreeBet promotions" />
            </div>
        );
    }
}

export default connect(
    state => ({
        event: state.smBrowser.event,
        user: state.user,
    }),
    dispatch => ({
        dispatch,
    }),
)(EventSMB);



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/event/EventBookieSMB.js
 **/